module.exports = __webpack_public_path__ + "static/media/blog.e17ba848.jpg";